import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * Standard list page surface. Renders flush (no border/radius/shadow of its own)
 * because it sits inside the Settings card panel — the panel is the surface, so
 * a self-contained card here would be a card-on-card double border. Mirrors
 * EntityIndexLayout's table container in its `hasWorkspaceHeader` (flush) branch.
 */
export function ListSurface({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('flex min-h-0 flex-1 flex-col overflow-hidden bg-card', className)}>
      {children}
    </div>
  );
}
